import { GlobalState } from "@/Reducers/interface";
import { ZModal } from "@atoms";
import {
	AnnouncementTemplateType,
	AnnouncementUserInteraction
} from "@/Contracts/Announcement";
import { useState } from "react";
import { useSelector } from "react-redux";
import AnnouncementTemplate1 from "./AnnouncementTemplate1";
import AnnouncementGoogleFormTemplate from "./AnnouncementGoogleFormTemplate";
import { registerAnnouncementUserInteraction } from "@/Services/Announcement";
import "./index.less";

const useAnnouncementModal = () => {
	const { announcement } = useSelector((state: GlobalState) => {
		return {
			announcement: state.announcement.announcement
		};
	});
	const [visible, setVisible] = useState(false);
	let AnnouncementModal: JSX.Element | null = null;
	const dismissAnnouncement = async () => {
		setVisible(false);
		if (!announcement) return;
		registerAnnouncementUserInteraction(
			announcement.id,
			AnnouncementUserInteraction.DISMISSED
		);
	};
	const remindLater = () => {
		setVisible(false);
		if (!announcement) return;
		registerAnnouncementUserInteraction(
			announcement.id,
			AnnouncementUserInteraction.REMIND_LATER
		);
	};
	const viewAnnouncement = async () => {
		setVisible(false);
		if (!announcement) return;
		registerAnnouncementUserInteraction(
			announcement.id,
			AnnouncementUserInteraction.VIEWED
		);
	};
	if (visible) {
		AnnouncementModal = (
			<ZModal
				className="announcement-modal"
				visible={visible}
				onCancel={dismissAnnouncement}
				footer={false}
				size={announcement?.modal_size ?? "sm"}
			>
				{announcement?.template_type ===
				AnnouncementTemplateType.Template1 ? (
					<AnnouncementTemplate1
						announcement={announcement}
						remindLater={remindLater}
						viewAnnouncement={viewAnnouncement}
					/>
				) : announcement?.template_type ===
				  AnnouncementTemplateType.GoogleFormTemplate ? (
					<AnnouncementGoogleFormTemplate
						announcement={announcement}
						remindLater={remindLater}
						viewAnnouncement={viewAnnouncement}
					/>
				) : null}
			</ZModal>
		);
	}
	return {
		showAnnouncementModal: setVisible,
		AnnouncementModal
	};
};

export default useAnnouncementModal;
